export default __webpack_public_path__ + "static/media/Support Button (7).571952cf.svg";